import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useFormik } from "formik";
import "./login.css";
import logo from "../../assets/Images/App Icon.png";
import login from "../../services/Authservice";
import { Snackbar } from "../../utils/snackbar";

function Signin() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setloading] = useState(false);

  const handleClose = (event, reason) => {
    setOpen(false);
  };

  const handleLogin = async (values) => {
    setloading(true);
    try {
      const data = await login(values);
      console.log(data);
      localStorage.setItem("Data", JSON.stringify(data.data.data));
      localStorage.setItem("ntk", data.data.data.token);
      setloading(false);
      navigate("/Dashboard");
    } catch (error) {
      setError(error.message);
      setOpen(true);
      setloading(false);
    }
  };

  const validate = (values) => {
    const errors = {};

    if (!values.email) {
      errors.email = "Required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (!values.password) {
      errors.password = "Required";
    } else if (values.password.length < 4) {
      errors.password = "Must be at least 4 characters";
    } else if (values.password.length > 20) {
      errors.password = "Must be 20 characters or less";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      handleLogin(values);
      // navigate("/Dashboard");
    },
  });

  return (
    <div className="App">
      <div className="Auth-form-container1">
        <div className="Auth-form1">
          <div className="Auth-logo">
            <img src={logo} />
          </div>
          <div className="Auth-form-content1">
            <h3 className="Auth-form-title">Log In</h3>
            <form onSubmit={formik.handleSubmit} className="Auth_formdata">
              <div className="form-group mt-3">
                <label className="Auth_label">Email address</label>
                <input
                  type="email"
                  className="Auth_input"
                  placeholder="Enter email"
                  name="email"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                {formik.errors.email ? (
                  <p className="invalid">{formik.errors.email} </p>
                ) : null}

                {/* <Form.Control.Feedback  className="invalid">
                    {emailError}
                  </Form.Control.Feedback> */}
              </div>
              <br />
              <div className="form-group mt-3">
                <label className="Auth_label">Password</label>
                <input
                  type="text"
                  name="password"
                  className="Auth_input"
                  placeholder="Enter password"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                {formik.errors.password ? (
                  <p className="invalid">{formik.errors.password} </p>
                ) : null}
              </div>

              <br />
              <p
                className="forgot-password"
                onClick={() => navigate("/ForgetPassword")}
              >
                Forgot password?
              </p>

              <div style={{ display: "flex", justifyContent: "left" }}></div>
              <button
                type="submit"
                className="btn-14"
                disabled={loading}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                <span>{loading ? "Loading...." : "Login"}</span>
              </button>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={open}
        severity="error"
        onclose={handleClose}
        message={error}
      />
    </div>
  );
}

export default Signin;
